import {
  CenterProps as MantineCenterProps,
  Center as MantineCenter,
} from '@mantine/core';

export type CenterProps = MantineCenterProps;

export const Center = MantineCenter as typeof MantineCenter;

Center.displayName = 'Center';
